export default __webpack_public_path__ + "static/media/copy-to-clipboard-btn.214bbe27.svg";